import { render, staticRenderFns } from "./DashboardTopBar.vue?vue&type=template&id=af6ddd96&scoped=true&"
import script from "./DashboardTopBar.vue?vue&type=script&lang=js&"
export * from "./DashboardTopBar.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTopBar.vue?vue&type=style&index=0&id=af6ddd96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6ddd96",
  null
  
)

/* custom blocks */
import block0 from "./DashboardTopBar.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports